import { useState } from "react";
import { fromDateTimeLocalValue, toDateTimeLocalValue } from "../../../utils/news";

const NEWS_LANGUAGES = [
    { code: "ro", titleField: "title", contentField: "content", label: "ROM", name: "Romana" },
    { code: "ru", titleField: "title_ru", contentField: "content_ru", label: "RUS", name: "Rusa" },
    { code: "en", titleField: "title_en", contentField: "content_en", label: "ENG", name: "Engleza" },
];

function NewsModal({
    news,
    setNews,
    imagePreview,
    uploading,
    translating,
    onImageChange,
    onTranslate,
    onSave,
    onSaveAndTranslate,
    onClose,
}) {
    const [activeLanguage, setActiveLanguage] = useState("ro");
    const currentLanguage = NEWS_LANGUAGES.find((language) => language.code === activeLanguage) || NEWS_LANGUAGES[0];
    const canTranslate = Boolean(news.title?.trim() && news.content?.trim());

    const updateField = (field, value) => {
        setNews((current) => ({ ...current, [field]: value }));
    };

    return (
        <div className="admin__modal-overlay" onClick={onClose}>
            <div className="admin__modal admin__modal--wide card-common" onClick={(e) => e.stopPropagation()}>
                <div className="admin__modal-title-row">
                    <h2>{news.id ? "Editeaza noutate" : "Adauga noutate"}</h2>
                    <button
                        type="button"
                        className="admin__btn-ai"
                        onClick={onTranslate}
                        disabled={!canTranslate || translating || uploading}
                    >
                        {translating ? "Se traduce..." : "Tradu cu AI"}
                    </button>
                </div>

                <form onSubmit={onSave}>
                    <div className="admin__form-grid">
                        <div className="admin__field">
                            <label>Data publicarii</label>
                            <input
                                type="datetime-local"
                                value={toDateTimeLocalValue(news.published_at)}
                                onChange={(e) => updateField("published_at", fromDateTimeLocalValue(e.target.value))}
                            />
                        </div>
                        <div className="admin__field">
                            <label>Sursa URL</label>
                            <input value={news.source_url || ""} onChange={(e) => updateField("source_url", e.target.value)} />
                        </div>
                        <div className="admin__field">
                            <label>Ordine</label>
                            <input
                                type="number"
                                value={news.sort_order || 0}
                                onChange={(e) => updateField("sort_order", e.target.value)}
                            />
                        </div>
                        <div className="admin__field">
                            <label className="admin__checkbox-field">
                                <input
                                    type="checkbox"
                                    checked={parseInt(news.is_published || 0) === 1}
                                    onChange={(e) => updateField("is_published", e.target.checked ? 1 : 0)}
                                />
                                <span>Publicata</span>
                            </label>
                        </div>
                        <div className="admin__field full">
                            <label>Imagine</label>
                            <div className="admin__image-upload">
                                <input type="file" accept="image/jpeg,image/png,image/gif,image/webp" onChange={onImageChange} />
                                {imagePreview && (
                                    <img
                                        src={imagePreview}
                                        alt="Preview noutate"
                                        className="admin__image-preview admin__image-preview--news"
                                    />
                                )}
                            </div>
                        </div>
                        <div className="admin__field full">
                            <div className="admin__language-tabs" role="tablist" aria-label="Limbi noutate">
                                {NEWS_LANGUAGES.map((language) => (
                                    <button
                                        key={language.code}
                                        type="button"
                                        role="tab"
                                        aria-selected={activeLanguage === language.code}
                                        className={`admin__language-tab ${activeLanguage === language.code ? "active" : ""}`}
                                        onClick={() => setActiveLanguage(language.code)}
                                    >
                                        {language.label}
                                    </button>
                                ))}
                            </div>

                            <div className="admin__language-panel" role="tabpanel">
                                <div className="admin__field">
                                    <label>Titlu {currentLanguage.name}{activeLanguage === "ro" ? " *" : ""}</label>
                                    <input
                                        value={news[currentLanguage.titleField] || ""}
                                        onChange={(e) => updateField(currentLanguage.titleField, e.target.value)}
                                        required={activeLanguage === "ro"}
                                    />
                                </div>
                                <div className="admin__field">
                                    <label>Continut {currentLanguage.name}{activeLanguage === "ro" ? " *" : ""}</label>
                                    <textarea
                                        rows="11"
                                        value={news[currentLanguage.contentField] || ""}
                                        onChange={(e) => updateField(currentLanguage.contentField, e.target.value)}
                                        required={activeLanguage === "ro"}
                                    />
                                </div>
                            </div>
                        </div>
                    </div>

                    <div className="admin__modal-actions">
                        <button type="button" onClick={onClose} disabled={uploading || translating}>
                            Anuleaza
                        </button>
                        <button
                            type="button"
                            className="secondary"
                            onClick={onSaveAndTranslate}
                            disabled={!canTranslate || uploading || translating}
                            title="Traduce titlul și conținutul din română în rusă și engleză (suprascrie filele RUS/ENG), apoi salvează.">
                            {translating ? "Se traduce..." : "Salveaza + tradu cu AI"}
                        </button>
                        <button
                            type="submit"
                            className="primary"
                            disabled={uploading || translating}
                            title="Salvează exact ce este scris în cele trei file, fără traducere automată.">
                            {uploading ? "Se salveaza..." : "Salveaza"}
                        </button>
                    </div>
                </form>
            </div>
        </div>
    );
}

export default NewsModal;
